import React from 'react'
import PropTypes from 'prop-types'

import { Border, Image, Wrapper } from 'Components/UI'

import { Container, Content, ImageHolder } from './styles'

function Hero({ data }) {
  return (
    <>
      <Container background={data?.background?.hex}>
        <Wrapper justifyContent="center" maxWidth={1774}>
          <Content>
            <ImageHolder>
              {/* The case-page LCP element — preload it (was lazy, a
                  react-datocms parity leftover). The real alt comes from
                  the record (image.alt) in the migrated-image branch. */}
              <Image alt="" image={data?.image} priority />
            </ImageHolder>
          </Content>
        </Wrapper>
      </Container>
      <Border bg={data?.background?.hex} topRight />
    </>
  )
}

Hero.defaultProps = {
  data: null,
}

Hero.propTypes = {
  data: PropTypes.object,
}

export default Hero
